var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table_wrapper" }, [
    _c("div", { ref: "floatHeader" }),
    _vm._v(" "),
    _c(
      "table",
      { staticStyle: { width: "100%", "min-width": "200px" } },
      [
        _c("thead", { ref: "tableHeader" }, [
          _c(
            "tr",
            [
              _vm._l(_vm.columns, function (head) {
                return head.visible
                  ? _c(
                      "th",
                      {
                        class: head.class,
                        attrs: {
                          "min-width": head.width + "px",
                          width: (head.width * 100) / _vm.totalWidth,
                        },
                      },
                      [_vm._v(_vm._s(head.text) + "\n          ")]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "td_accion",
                  attrs: { "min-width": "100px", width: "1px" },
                },
                [_vm._v("Acciones")]
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.data, function (item, key) {
              return _vm.multiple != true
                ? _c(
                    "tr",
                    [
                      _vm._l(_vm.columns, function (head) {
                        return head.visible
                          ? [
                              head.html
                                ? _c("td", {
                                    class: [item.en_uso_actual ? "activo" : ""],
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.format(head, item, key)
                                      ),
                                    },
                                  })
                                : _c(
                                    "td",
                                    {
                                      class: [
                                        item.en_uso_actual ? "activo" : "",
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.format(head, item, key)) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "td_accion" },
                        [
                          _vm._t(
                            "actions",
                            function () {
                              return [_vm._v(" ")]
                            },
                            { item: item, idx: key }
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  )
                : _vm._l(_vm.data, function (mitem, key) {
                    return _c(
                      "tr",
                      [
                        _vm._l(mitem, function (item, skey) {
                          return [
                            skey == 0
                              ? [
                                  _vm._l(_vm.columns, function (head) {
                                    return head.visible
                                      ? [
                                          head.multiple
                                            ? _c(
                                                "td",
                                                {
                                                  class: [
                                                    item && item.carrera_publica
                                                      ? "carrera_publica"
                                                      : "experiencia_laboral",
                                                  ],
                                                },
                                                [
                                                  head.html
                                                    ? _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.format(
                                                              head,
                                                              item,
                                                              key
                                                            )
                                                          ),
                                                        },
                                                      })
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.format(
                                                              head,
                                                              item,
                                                              key
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    rowspan: mitem.length,
                                                  },
                                                },
                                                [
                                                  head.html
                                                    ? _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.format(
                                                              head,
                                                              item,
                                                              key
                                                            )
                                                          ),
                                                        },
                                                      })
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.format(
                                                              head,
                                                              item,
                                                              key
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]
                                              ),
                                        ]
                                      : _vm._e()
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { attrs: { rowspan: mitem.length } },
                                    [
                                      _vm._t(
                                        "actions",
                                        function () {
                                          return [_vm._v(" ")]
                                        },
                                        { item: item, idx: item }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              : [
                                  _vm._l(_vm.columns, function (head) {
                                    return head.visible
                                      ? [
                                          head.multiple
                                            ? _c("td", { class: item.class }, [
                                                head.html
                                                  ? _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.format(
                                                            head,
                                                            item,
                                                            key
                                                          )
                                                        ),
                                                      },
                                                    })
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.format(
                                                            head,
                                                            item,
                                                            key
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                              ])
                                            : _vm._e(),
                                        ]
                                      : _vm._e()
                                  }),
                                ],
                          ]
                        }),
                      ],
                      2
                    )
                  })
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("tfoot"),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }